<template>
  <div class="mes-header-wrapper">
    <header class="mes-header">
      <div class="mes-header__content">
        <!-- logo -->
        <h1>
          <router-link to="/">
            <img
              :src="require('@/assets/images/logo.png')"
              alt="logo"
              class="mes-header__logo"
              style="height:60px;width:120px"
            />
          </router-link>
        </h1>
        <!-- 菜单 -->
        <ul class="mes-nav">
          <li class="mes-nav__item">
            <menu-link :to="'index'">
              {{ $t('home') }}
            </menu-link>
          </li>

          <li v-for="item of homeMenu" :key="item.id" class="mes-nav__item">
            <menu-link :to="item.menuUrl" :query="item.id.toString()">
              {{ getmenu(item) }}
            </menu-link>
          </li>

          <!-- <li class="mes-nav__item">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link"> APP <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                   <el-image
                  style="width: 180px; height: 180px"
                  :src="src"
                  :fit="'fit'"></el-image>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="mes-nav__item">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link"> {{ $t('mobile') }} <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                   <el-image
                  style="width: 180px; height: 180px"
                  :src="src1"
                  :fit="'fit'"></el-image>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="mes-nav__item">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link"> {{ $t('trainexam') }} <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                   <el-image
                  style="width: 180px; height: 180px"
                  :src="src2"
                  :fit="'fit'"></el-image>
              </el-dropdown-menu>
            </el-dropdown>
          </li> -->
          <!-- <li class="mes-nav__item">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                {{ $t('appliaction') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                <el-dropdown-item >
                   <menu-link :to="hsseWebUrl" >
                     {{ $t('backManager') }}
                   </menu-link>
                </el-dropdown-item>
                <el-dropdown-item >
                   <menu-link :to="hsseWebCBSUrl">
                      {{ $t('self_platform') }}
                  </menu-link>
                </el-dropdown-item>
                  <el-dropdown-item >
                   <menu-link :to="hsseExamUrl">
                      {{ $t('exam_platform') }}
                  </menu-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li> -->
          <!-- <li class="mes-nav__item" >
            <router-link v-if="token" to="/welcome">{{ $t('goBackgourd') }}</router-link>
            <el-dropdown v-else trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t('sysLogin') }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                <el-dropdown-item command="system">
                  {{ $t('sysManagelogin') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li> -->
          <li class="mes-nav__item">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t('language') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                <el-dropdown-item command="Chinese">
                  中文
                </el-dropdown-item>
                <el-dropdown-item command="English">
                  English
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </header>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import MenuLink from '../sidebar/link';
import { mapGetters } from 'vuex';
import Cookie from '@/utils/cookie';

export default {
  name: 'Header',
  components: {
    MenuLink
  },
  inject: ['reload'],
  data() {
    return {
      origin: {},
      src: require('@/assets/images/APP.png'),
      src1: require('@/assets/images/APPLogin.png'),
      src2: require('@/assets/images/APPExamLogin.png'),
      hsseWebUrl: process.env.VUE_APP_HSSEWEB,
      hsseWebCBSUrl: process.env.VUE_APP_HSSEWEBCBS,
      hsseExamUrl: process.env.VUE_APP_HSSEWEBEXAM
    };
  },
  computed: {
    ...mapGetters(['homeMenu', 'token'])
  },
  mounted() {},
  methods: {
    // 系统登录菜单项触发的事件回调
    async handleCommand(command) {
      switch (command) {
        case 'system': // 系统管理登录
          this.$router.push({
            path: '/home/login'
          });
          break;
        case 'Chinese':
          this.$i18n.locale = 'zh';
          Cookie.set('lanConfig', 'zh', 30);
          this.reload();
          break;
        case 'English':
          this.$i18n.locale = 'en';
          Cookie.set('lanConfig', 'en', 30);
          this.reload();
          break;
      }
    },
    getmenu(item) {
      return Cookie.get('lanConfig') === 'en' ? item.enMenuName : item.menuName;
    }
  }
};
</script>

<style lang="scss">
@include b(header-wrapper) {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: $header-height-large;
  z-index: 1500;
  border-bottom: 1px solid $border-color-base;
}
@include b(header) {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: $header-height-large;
  line-height: $header-height-large;
  background-color: $color-white;
  color: $color-white;
  z-index: 100;
  h1 {
    float: left;
    margin: 0;
    font-size: $font-size-extra-large-x;
    a {
      display: block;
      text-decoration: none;
    }
  }
  @include e(logo) {
    vertical-align: middle;
  }
  @include e(content) {
    width: $container-width;
    height: 100%;
    margin: 0 auto;
    box-sizing: border-box;
  }
}

@include b(nav) {
  float: right;
  height: 100%;
  margin: 0;
  padding: 0;
  line-height: $header-height-large;
  background: transparent;
  @include e(item) {
    position: relative;
    float: left;
    margin: 0;
    list-style: none;
    cursor: pointer;
    .el-dropdown,
    a {
      display: block;
      margin: 0 24px;
      color: $color-black;
    }
    .el-dropdown {
      height: 42px;
    }
    a {
      text-decoration: none;
      &:hover,
      &.router-link-exact-active {
        color: $color-primary;
      }
      &.router-link-exact-active {
        border-bottom: 2px solid $color-primary;
      }
    }
  }
}
</style>
